export default __webpack_public_path__ + "static/media/expl-nn_12_EN.6f0b8137.png";